<template lang="pug">
div
  v-dialog(:value="!!showDetails" @input="showDetails = null" max-width="900")
    extra-content(:extra="{content: showDetails}")

  v-card.mb-3
    v-card-title.title.grey.lighten-4 {{ extra.name }}
    v-card-text
      v-form(ref="form" lazy-validation)
        template(v-for="(crumb, crumbI) in breadcrumb")
          div.grey.lighten-3(@click="cancelEdit(crumbI)")
            v-btn(icon): v-icon arrow_drop_up
            |  {{selectVorgaben.byId[crumb].name}}
          v-divider
        .pb-3
        template(v-for="v in currentChildren")
          div(@click="selectVorgabe(v.id)")
            v-btn(icon): v-icon arrow_right
            span  {{v.name}}&#32;
          v-divider

        .pa-3(v-html="lastVorgabe.beschreibung")
        v-alert(:value="!!msg" dismissible @input="msg = null" type="success") {{msg}}
        v-alert(:value="!!error" dismissible @input="error = null" type="error") {{error}}
        v-layout(row wrap v-if="edit && effectiveValues.formular")
          template(v-if="effectiveValues.helpcontents.length > 0 ")
            v-flex(xs12): v-card(class="helpyourself")
              v-card-title.subtitle-2.green.lighten-4 Vielleicht kannst du das Problem auch direkt selbst lösen. Schau dir zunächst unsere Lösungvorschläge an:
              v-card-text
                template(v-for="help in effectiveValues.helpcontents")
                  v-layout(wrap)
                    v-flex(xs6): v-btn(@click="show(help)") {{ help.title }} - Hilfe anzeigen
            v-flex(xs12): v-checkbox(v-model="helpread" :label="`Ich habe mir die Lösungsvorschläge angeschaut, sie helfen mir leider nicht weiter.`").mb-5
          template(v-if="helpread || effectiveValues.helpcontents.length == 0")
            template(v-if="!user")
              | Bitte melde dich an um ein Ticket aufzugeben.
            template(v-else)
              v-flex(xs12 sm4): v-text-field(label="Vorname" v-model="user.vorname" disabled)
              v-flex(xs12 sm4): v-text-field(label="Nachname" v-model="user.nachname" disabled)
              v-flex(xs12 sm4): v-text-field(label="E-Mail" v-model="user.email" disabled)
              v-flex(xs12 v-if="effectiveValues.formularBetreff"): v-text-field(label="Betreff" v-model="edit.betreff" :rules="[required]")
              v-flex(xs12 v-if="effectiveValues.formularText"): v-textarea(label="Text" v-model="edit.text" auto-grow)
              v-flex(xs12 v-if="effectiveValues.formularDateien")
                template(v-for="datei in edit.dateien")
                  file-input(v-model="datei.name" base64 @base64="updateDatei(datei, $event)" clearable)
                file-input(v-model="neueDateiName" base64 @base64="addDatei")
    v-card-actions(v-if="edit && edit.userId && effectiveValues.formular && (helpread || effectiveValues.helpcontents.length == 0)")
      v-btn(outline color="primary" @click="save" :loading="loading > 0") Ticket Erstellen
      v-btn(outline @click="cancelEdit()") Abbrechen

</template>
<style lang="stylus" scoped>
.helpyourself.helpyourself
  border solid 2px #c8e6c9

</style>
<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import { user } from '../../router'
import { sortBy, uniq, uniqBy, flatten } from "lodash"
import ExtraContent from './extra-content'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  components: {
    ExtraContent,
  },
  data() {
    return {
      user,
      msg: null,
      error: null,
      breadcrumb: [],
      itTicketVorgaben: [],
      neueDatei: null,
      neueDateiName: null,
      edit: null,
      loading: 0,
      showDetails: null,
      helpread: false,
    }
  },
  apollo: {
    itTicketVorgaben: gql`query ExtraItTicketVorgabenBearbeitenVue {
      itTicketVorgaben {
        id
        name
        beschreibung
        ancestorIds
        parentId
        prio
        tags
        team
        personId
        formular
        formularText
        formularBetreff
        formularDateien
        brauchtFreigabe
        contents {
          id
          title
          preamble
          content
          downloads {
            id
            url
            title
          }
          previewImage
        }
      }
    }`
  },
  computed: {
    selectVorgaben() {
      const vorgaben = this.itTicketVorgaben.map(v => ({
        ...v,
        label: `${v.ancestorIds.map(() => " -").join("")} ${v.name}`,
        sort: v.ancestorIds.length ? v.ancestorIds.join("/") : "0"
      }));
      let nodes = sortBy(vorgaben, ["sort", "name"]);
      const extra = this.extra
      const rootId = extra && extra.options && extra.options.xid || null
      if (rootId) {
        nodes = nodes.filter(n => n.id == rootId || n.ancestorIds[0] == rootId)
      };

      const byId = {};
      let children = {};
      nodes.forEach(node => {
        byId[node.id] = node;
        if (children[node.parentId]) {
          children[node.parentId].push(node.id);
        } else {
          children[node.parentId] = [node.id];
        }
      });
      function buildTree(nodes, current, list) {
        list.push(current);
        if (nodes[current]) {
          const node = {};
          nodes[current].forEach(id => {
            node[id] = buildTree(nodes, id, list);
          });
          return node;
        } else {
          return {};
        }
      }
      let list = [];
      const tree = buildTree(children, null, list);
      list.shift();
      list = list.map(id => byId[id]);
      return { tree, list, children, byId, rootId: rootId };
    },
    lastVorgabe() {
      const vorgaben = this.selectVorgaben
      const breadcrumb = this.breadcrumb
      return vorgaben.byId[breadcrumb[breadcrumb.length -1] || vorgaben.rootId] || {}
    },
    currentChildren() {
      const vorgaben = this.selectVorgaben;
      return (
        vorgaben.children[
          this.breadcrumb[this.breadcrumb.length - 1] || vorgaben.rootId
        ] || []
      ).map(id => vorgaben.byId[id]);
    },
    effectiveValues() {
      const vorgaben = this.selectVorgaben;
      const ancestors = this.breadcrumb.map(id => vorgaben.byId[id]).reverse()
      ancestors.push({
        prio: 3,
        tags: [],
        personId: null,
        team: null,
        formular: true,
        formularBetreff: false,
        formularText: true,
        formularDateien: true,
        brauchtFreigabe: false,
        helpcontents: [],
      })
      return {
        prio: ancestors.map(a => a.prio).find(prio => prio),
        tags: uniq(flatten(ancestors.map(a => a.tags))).sort(),
        team: ancestors.map(a => a.team).find(team => team),
        formular: ancestors.map(a => a.formular).find(f => f !== null),
        formularBetreff: ancestors.map(a => a.formularBetreff).find(f => f !== null),
        formularText: ancestors.map(a => a.formularText).find(f => f !== null),
        formularDateien: ancestors.map(a => a.formularDateien).find(f => f !== null),
        brauchtFreigabe: ancestors.map(a => a.brauchtFreigabe).find(f => f !== null),        
        helpcontents: uniqBy(flatten(ancestors.map(a => a.contents).filter(c => c)), 'title'),
      }
    },
  },
  methods: {
    show(content) {
      this.showDetails = content
      this.showDetails.media = this.showDetails.previewImage
      this.showDetails = JSON.stringify([this.showDetails])
    },
    addDatei(base64) {
      this.edit.dateien.push({
        name: this.neueDateiName,
        data: base64
      })
      this.neueDatei = null
      this.neueDateiName = null
    },
    updateDatei(datei, base64) {
      datei.data = base64
      if (!base64) {
        const dateien = this.edit.dateien
        const n = dateien.indexOf(datei)
        if (n >=0) {
          dateien.splice(n, 1)
        }
      }
    },
    isLeaf(id) {
      const children = this.selectVorgaben.children
      return !(children[id] && children[id].length)
    },
    selectVorgabe(id) {
      this.msg = null
      this.error = null
      this.breadcrumb.push(id)
      if (this.isLeaf(id)) {
        this.startEdit(id)
      }
    },
    startEdit(id) {
      this.edit = {
        userId: user && user.id,
        vorgabeId: id,
        betreff: '',
        text: '',
        dateien: [],
      }
    },
    cancelEdit(crumbI = this.breadcrumb.length -1) {
      this.msg = null
      this.error = null
      this.edit = null
      this.breadcrumb = this.breadcrumb.slice(0, crumbI)
      this.helpread = false
    },
    required(v) {
      return !!v || 'muss ausgefüllt werden'
    },
    save() {
      this.msg = null
      this.error = null
      this.validated = true
      this.gqlClearAllErrors()
      if (!this.$refs.form.validate()) {
        this.error = 'Bitte Überprüfen Sie Ihre eingaben.'
        return
      }
      this.loading++
      this.$apollo.mutate({
        mutation: gql`mutation (
            $userId: ID!
            $vorgabeId: ID
            $betreff: String
            $text: String
            $dateien: [Base64FileInput]
        ) {
          itTicketCreate(
            userId: $userId
            vorgabeId: $vorgabeId
            betreff: $betreff
            text: $text
            dateien: $dateien
          ) { id }
        }`,
        variables: this.edit,
      }).then((response) => {
        this.loading--
        if (response.data.itTicketCreate.id) {
          this.cancelEdit(0)
          this.msg = 'Ticket Aufgegeben.'
        } else {
          this.error = 'Ein Fehler is aufgetreten.'
        }
      }, (error) => {
        this.loading--
        this.gqlAddErrors(error)
        this.error = 'Ein Fehler is aufgetreten.'
      })
    },
  }
}
</script>
